<template>
  <div>
    <a-row :gutter="16">
      <a-col span="24">
        <div class="panel panel-default panel-stretch">
          <div class="panel-heading">
            Taken
          </div>
          <div class="panel-body no-padding">
            <a-row>
              <a-col :span="6" style="padding: 1.5rem; border-right: 1px solid #eeeeee"
              >
                <div class="form-group">
                  <label class="control-label">Periode</label>
                  <div>
                    <a-date-picker
                        v-model:value="startDate"
                        :format="DateFormatEnum.DISPLAY_DATE"
                        placeholder="Selecteer startdatum"
                        style="width: 45%"
                    />
                    <span style="width: 7%; display: inline-block; font-size: 70%">t/m</span>
                    <a-date-picker
                        v-model:value="endDate"
                        :format="DateFormatEnum.DISPLAY_DATE"
                        placeholder="Selecteer einddatum"
                        style="width: 45%"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Product categorie</label>
                  <div>
                    <Skeleton height="32" :loading="categoryLoading">
                      <a-select allowClear
                                placeholder="Selecteer categorie"
                                style="width: 100%"
                                v-model="filter.category_id"
                      >
                        <a-select-option v-for="category in categories" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </a-select-option>
                      </a-select>
                    </Skeleton>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Status</label>
                  <div>
                    <a-checkbox-group v-model:value="filter.status" style="width: 100%">
                      <a-checkbox :value="0">
                        Actief
                      </a-checkbox>
                      <br/>
                      <a-checkbox :value="1">
                        Afgerond
                      </a-checkbox>
                      <br/>
                      <a-checkbox :value="null">
                        Onbekend
                      </a-checkbox>
                    </a-checkbox-group>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Label</label>
                  <div>
                    <Skeleton height="32" :loading="productLoading">
                      <a-select allowClear
                                placeholder="Selecteer label"
                                style="width: 100%"
                                v-model="filter.productLabel"
                      >
                        <a-select-option v-for="productLabel in productLabels" :key="productLabel.id"
                                         :value="productLabel.id">
                          {{ productLabel.name }}
                        </a-select-option>
                      </a-select>
                    </Skeleton>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Adviseur</label>
                  <div>
                    <Skeleton height="32" :loading="userLoading">
                      <a-select allowClear
                                placeholder="Selecteer adviseur"
                                style="width: 100%"
                                v-model="filter.user_id"
                      >
                        <a-select-option v-for="user in users" :key="user.id"
                                         :value="user.id">
                          {{ user.fullname }}
                        </a-select-option>
                      </a-select>
                    </Skeleton>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Afdeling</label>
                  <div>
                    <Skeleton height="32" :loading="departmentLoading">
                      <a-select allowClear
                                placeholder="Selecteer Afdeling"
                                style="width: 100%"
                                v-model="filter.department"
                      >
                        <a-select-option v-for="department in departments" :key="department.id"
                                         :value="department.id">
                          {{ department.name }}
                        </a-select-option>
                      </a-select>
                    </Skeleton>
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Zoek op woord</label>
                  <div>
                    <a-input
                        :allow-clear="true"
                        style="min-width: 130px"
                        v-on:click.stop
                        v-model="filter.searchTerm"
                        placeholder="vb: aflossingsvrij.."
                    />
                  </div>
                </div>
                <div class="form-group">
                  <a-button type="primary" @click="getTasks()">Zoek met deze filters</a-button>
                  <a-button type="link" @click="resetFilters">reset filters</a-button>
                </div>
              </a-col>
              <a-col :span="17" style="padding: 1.5rem 0 1.5rem 1.5rem;">
                <a-spin tip="laden..." :spinning="tasksLoading">

                  <div class="row">
                    <div class="col-md-6">
                      <div style="margin-bottom: 20px">
                        <b>{{ totalTasks }} {{ tasksDescription }}</b>
                        van {{ startDate.format(DateFormatEnum.DISPLAY_DATE) }}
                        t/m {{ endDate.format(DateFormatEnum.DISPLAY_DATE) }}
                      </div>
                    </div>
                    <div class="col-md-6 pull-right">
                      <a-button type="primary" :href="exportHref" target="_blank" style="float: right">
                        Export naar excel
                      </a-button>
                    </div>
                  </div>
                  <a-switch v-model:checked="showDescription"/>
                  Toon omschrijving
                  <br/>
                  <br/>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th class="compact">
                        <order-by :order="filter.order" :select="filter.orderBy" value="category_id"
                                  @change="onOrderByChange">
                          Categorie
                        </order-by>
                      </th>
                      <th class="compact">
                        <order-by :order="filter.order" :select="filter.orderBy" value="content"
                                  @change="onOrderByChange"> Taak
                        </order-by>
                      </th>
                      <th v-if="showDescription" class="compact">
                        Omschrijving
                      </th>
                      <th class="compact">
                        Labels
                      </th>
                      <th class="compact">
                        Klant
                      </th>
                      <th class="compact">
                        Adviseur
                      </th>
                      <th class="compact">
                        Datum
                      </th>
                      <th class="compact">
                        Behandelaar
                      </th>
                      <th class="compact">
                        <order-by :order="filter.order" :select="filter.orderBy" value="status"
                                  @change="onOrderByChange">Status
                        </order-by>
                      </th>
                    </tr>
                    </thead>

                    <tbody>
                    <RowComponent v-for="task in tasks" :key="task.id" :task="task" :showDescription="showDescription"
                                  :category="getCategory(task)"></RowComponent>
                    </tbody>
                  </table>

                  <div v-if="hasTasks" class="panel-body" style="padding-top: 0;">
                    <laravel-pagination
                        v-if="displayPagination"
                        :data="currentRequestData"
                        @pagination-change-page="getTasks"
                        style="margin: 0;"
                    ></laravel-pagination>
                  </div>
                </a-spin>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton';
import RowComponent from "./RowComponent";
import categoryApi from '~/api/category'
import productLabelApi from '~/api/product_label'
import taskApi from '~/api/task'
import userApi from '~/api/user'
import userDepartmentApi from '~/api/user_department'
import DateFormatEnum from "~/enums/DateFormatEnum";
import moment from 'moment';

export default {
  name: "ReportingTasksOverviewComponent",
  data() {
    return {
      DateFormatEnum,
      categories: [],
      productLabels: [],
      users: [],
      departments: [],
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
      filter: {
        category_id: undefined,
        status: [],
        productLabel: undefined,
        user_id: undefined,
        department: undefined,
        searchTerm: undefined,
        orderBy: 'created_at',
        order: 'desc',
      },
      filterUsedInSearch: {},
      tasks: [],
      totalTasks: 0,
      categoryLoading: true,
      departmentLoading: true,
      productLoading: true,
      tasksLoading: false,
      userLoading: true,
      currentRequestData: {},
      showDescription: false,
    }
  },
  computed: {
    tasksDescription() {
      if (this.tasks && this.tasks.length === 1) {
        return 'taak'
      }
      return 'taken'
    },
    hasTasks() {
      return (this.initialized && this.tasks.length > 0) || !this.initialized;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    exportHref() {
      let uri = "/web_api/v1/task/filtered/export?";
      let params = '';
      let filter = this.filterUsedInSearch;
      Object.keys(this.filterUsedInSearch).forEach(function (key) {
        if (filter[key] !== undefined) {
          params += '&' + key + '=' + filter[key]
        }
      });
      uri += params.substring(1);
      return uri
    }
  },
  mounted() {
    categoryApi.getCategories().then(response => {
      this.categories = response.data
      this.categoryLoading = false
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om categorieën te laden',
      });
    }).finally(() => {
      this.categoryLoading = false
    })
    productLabelApi.getByProductCategory('task').then(response => {
      this.productLabels = response.data
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om product labels te laden',
      });
    }).finally(() => {
      this.productLoading = false
    })
    userApi.paginateActive(1, 500).then(response => {
      this.users = response.data
      this.userLoading = false
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om adviseurs te laden',
      });
    }).finally(() => {
      this.userLoading = false
    })
    userDepartmentApi.index().then(response => {
      this.departments = response.data
    }).catch(() => {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om afdelingen te laden',
      });
    }).finally(() => {
      this.departmentLoading = false
    })
    this.getTasks()
  },

  methods: {
    moment,
    getTasks(page = 1) {
      this.tasksLoading = true
      let filter = this.filter
      filter.startDate = this.startDate.format(DateFormatEnum.DATE);
      filter.endDate = this.endDate.format(DateFormatEnum.DATE);
      filter.page = page;
      this.filterUsedInSearch = JSON.parse(JSON.stringify(filter));
      taskApi.getTasksByFilter(filter).then(response => {
        this.tasks = response.data;
        this.currentRequestData = response;
        if (response && response.meta && response.meta.pagination && response.meta.pagination.total) {
          this.totalTasks = response.meta.pagination.total
        } else if (response.data && response.data.length > 0) {
          this.totalTasks = response.data.length
        } else {
          this.totalTasks = 0;
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Het is niet gelukt om taken te laden',
        });
      }).finally(() => {
        this.tasksLoading = false
      })
    },
    getCategory(task) {
      if (!task.category_id) {
        return null
      }
      const category = this.categories.filter(item => item.id === task.category_id)
      if (!category || category.length === 0) {
        return null
      }
      return category[0]
    },
    resetFilters() {
      this.filter = {
        category_id: undefined,
        status: [],
        productLabel: undefined,
        user_id: undefined,
        department: undefined,
        searchTerm: undefined,
      }
      this.startDate = moment().subtract(7, 'days')
      this.endDate = moment()
      this.getTasks()
    },
    onOrderByChange(orderBy, order) {
      this.filter.orderBy = orderBy
      this.filter.order = order
      this.getTasks()
    },
  },

  components: {
    Skeleton,
    RowComponent,
  },
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}

.staticSearchItem {
  float: left;
  width: 33.33%;
  padding: 1rem 2rem;
}

</style>